// (2026-05-17) FIND-3 + FIND-7 — Idioma español GLOBAL para DataTables.
//
// Problema detectado en QA:
//  - FIND-3: las listas con bloque `language` propio NO definían `emptyTable`,
//    por lo que la tabla vacía mostraba el texto por defecto en inglés
//    ("No data available in table").
//  - FIND-7: la lista de Productos no pasa ningún `language`, por lo que
//    TODOS sus controles salían en inglés ("Search:", "entries per page").
//
// Solución de bajo riesgo y sin tocar las 15 vistas fiscales: se fija el
// idioma por defecto del core de DataTables. DataTables hace un merge
// PROFUNDO de `defaults.language` con el `language` que cada componente
// pasa en sus `options`, por lo que:
//   • las claves que cada vista ya define siguen mandando (no cambia nada);
//   • las claves que faltan (p. ej. `emptyTable`) se completan con este ES;
//   • las vistas sin `language` (Productos) quedan 100% en español.
//
// Import de SOLO EFECTO en App.js: `import "./utils/datatablesEs";`
import DT from "datatables.net-dt";

export const DT_LANG_ES = {
  decimal: ",",
  thousands: ".",
  emptyTable: "No hay registros disponibles",
  zeroRecords: "No se encontraron resultados",
  lengthMenu: "Mostrar _MENU_ registros por página",
  info: "Mostrando de _START_ a _END_ de _TOTAL_ registros",
  infoEmpty: "No hay registros disponibles",
  infoFiltered: "(filtrado de _MAX_ registros totales)",
  search: "Buscar:",
  loadingRecords: "Cargando…",
  processing: "Procesando…",
  paginate: {
    first: "Primero",
    last: "Último",
    next: "Siguiente",
    previous: "Anterior",
  },
  aria: {
    sortAscending: ": activar para ordenar la columna de manera ascendente",
    sortDescending: ": activar para ordenar la columna de manera descendente",
  },
  buttons: {
    copy: "Copiar",
    print: "Imprimir",
    colvis: "Columnas",
  },
};

// Defensivo: si la API del core cambia en una versión futura, NO debe romper
// el arranque de la aplicación (sistema fiscal en producción).
try {
  if (DT && DT.defaults) {
    DT.defaults.language = { ...(DT.defaults.language || {}), ...DT_LANG_ES };
  }
} catch (e) {
  // Silencioso a propósito: el idioma es cosmético, jamás bloqueante.
}

export default DT_LANG_ES;
